module.exports = __webpack_public_path__ + "static/img/qualifications_row_14.7386bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_14.png
// module id = GOUK
// module chunks = 1